<h4>Earn interest by staking an amount of cash</h4>
<h5>Interest rate: 8%/round</h5>
<div fxLayout="column" style="min-width: 550px;">
    <div fxLayout="row" fxLayoutAlign="center center">
        <h3 style="width: 250px;">
            <mat-form-field appearance="fill">
                <mat-label>Amount to stake</mat-label>
                <input class="cash-value" matInput type="number" [min]="0" [max]="cash" [value]="stakeAmount" (change)="stakeAmount = $event.target.value">
            </mat-form-field>
            <mat-slider style="width: 100%;" [disabled]="cash == undefined" [value]="stakeAmount" [step]="1" [min]="0" [max]="cash" (change)="stakeAmount = $event.value"></mat-slider>
        </h3>
        <h3>Cash available: <span class="cash-value">{{cash - stakeAmount}}</span></h3>
    </div>
    <button [disabled]="(stakeAmount == 0)" mat-raised-button color="primary" (click)="apply()">Stake</button>
</div>
